// Material Kit 2 React pages
import AdvisoryBoard from "pages/AdvisoryBoard";

export default function AdvisoryBoardPage() {
  return <AdvisoryBoard />;
}
